export const WHATSAPP_NUMBER = "552731911819";
export const WHATSAPP_DISPLAY = "(27) 3191-1819";
export const INSTAGRAM = "playtoys.es";
export const INSTAGRAM_URL = "https://instagram.com/playtoys.es";
export const EXTRA_PLUSH_PRICE = 15;

export const waLink = (msg = "Olá, Play Toys! Quero saber mais sobre o aluguel da máquina de pelúcias.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const brl = (v) =>
  Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const brl0 = (v) =>
  Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

const BASE = ["Máquina de pelúcia por 4 horas", "Jogadas ilimitadas", "Translado e montagem", "Monitor durante toda a locação"];

export const PACKAGES = [
  { id: "pacote-1", number: "01", label: "Pacote 01", line: "pelucias", hours: 4, short: "Sem pelúcias · 4h · monitor", name: "Só a Máquina", price: 1200, plushies: 0,
    tagline: "Você escolhe os prêmios, a gente leva a emoção.",
    features: BASE, note: "Não inclui pelúcias" },
  { id: "pacote-2", number: "02", label: "Pacote 02", line: "pelucias", hours: 4, short: "50 pelúcias · 4h · monitor", name: "50 Pelúcias", price: 1800, plushies: 50, featured: true,
    tagline: "A máquina cheia, pronta pra festa.",
    features: [...BASE, "50 pelúcias inclusas"] },
  { id: "pacote-3", number: "03", label: "Pacote 03", line: "pelucias", hours: 4, short: "100 pelúcias · 4h · monitor", name: "100 Pelúcias", price: 2500, plushies: 100,
    tagline: "Pra festa grande, com prêmio de sobra.",
    features: [...BASE, "100 pelúcias inclusas"] },
  { id: "capsulas-1", number: "01", label: "Cápsulas 01", line: "capsulas", hours: 4, short: "Cápsulas · 4h · monitor", name: "Cápsulas 4h", price: 1400, plushies: 0, noExtras: true,
    tagline: "Indicado para eventos corporativos.",
    features: ["Máquina com cápsulas por 4 horas", "Jogadas ilimitadas", "Translado", "Monitor incluso"] },
  { id: "capsulas-2", number: "02", label: "Cápsulas 02", line: "capsulas", hours: 12, short: "Cápsulas · diária 12h · suporte virtual", name: "Cápsulas Diária", price: 1500, plushies: 0, noExtras: true,
    tagline: "Indicado para eventos corporativos de dia inteiro.",
    features: ["Máquina com cápsulas por 12 horas", "Jogadas ilimitadas", "Suporte virtual durante todo o evento (caso necessário)"],
    note: "Sem monitor" },
];

export const CITIES = ["Vitória", "Vila Velha", "Serra", "Cariacica", "Viana", "Guarapari", "Fundão"];
export const OTHER_CITY = "Outra cidade do ES";

export const STEPS = [
  { n: "01", title: "Escolha o pacote", text: "Com ou sem pelúcias. Precisa de mais prêmios? Cada pelúcia extra sai por R$ 15." },
  { n: "02", title: "Reserve on-line", text: "Informe data e local e garanta o dia: pague tudo com 5% de desconto ou só 30% de sinal." },
  { n: "03", title: "A gente leva e monta", text: "Translado e montagem inclusos. Um monitor acompanha a máquina durante toda a locação." },
  { n: "04", title: "4 horas de jogadas ilimitadas", text: "Os convidados jogam à vontade — de criança a avô — e a festa ganha uma atração que ninguém esquece." },
];

export const GALLERY = [
  { id: "g1", src: "/media/evento-1.jpg", category: "Pelúcias conquistadas", type: "photo" },
  { id: "g2", src: "/media/evento-3.jpg", category: "Pronto pra jogar", type: "photo" },
  { id: "g3", src: "/media/evento-2.jpg", category: "Até a princesa jogou", type: "photo" },
  { id: "g4", src: "/media/evento-4.jpg", category: "Diversão em família", type: "photo" },
];

export const FAQ = [
  { q: "Como funciona o aluguel?", a: "Levamos a máquina até o seu evento, fazemos a montagem e deixamos um monitor acompanhando durante as 4 horas de locação. Os convidados jogam de forma ilimitada." },
  { q: "As pelúcias estão inclusas?", a: "Depende do pacote: o Pacote 1 não inclui pelúcias, o Pacote 2 inclui 50 e o Pacote 3 inclui 100. Em qualquer pacote você pode adicionar pelúcias extras por R$ 15,00 a unidade." },
  { q: "Quais regiões vocês atendem?", a: "Atendemos todo o Espírito Santo. Os valores dos pacotes são referentes aos municípios da Grande Vitória; para as demais regiões, consulte o valor do deslocamento pelo WhatsApp." },
  { q: "Quais são as formas de pagamento?", a: "Você pode pagar o valor total on-line com 5% de desconto, ou reservar a data com uma entrada de 30% e quitar o restante até 10 dias antes do evento." },
  { q: "Quando minha data fica garantida?", a: "Assim que o pagamento on-line (integral ou sinal de 30%) é confirmado, sua reserva entra na nossa agenda." },
  { q: "Posso tirar dúvidas antes de reservar?", a: `Claro! Fale com a gente no WhatsApp ${WHATSAPP_DISPLAY} ou no Instagram @${INSTAGRAM}.` },
];

export const STATUS = {
  aguardando_pagamento: { label: "Aguardando pagamento", cls: "bg-zinc-700/40 text-zinc-200 border-zinc-500/40" },
  sinal_pago: { label: "Sinal pago", cls: "bg-amber-500/15 text-amber-300 border-amber-400/40" },
  pago: { label: "Pago 100%", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-400/40" },
  concluido: { label: "Concluído", cls: "bg-sky-500/15 text-sky-300 border-sky-400/40" },
  cancelado: { label: "Cancelado", cls: "bg-red-500/15 text-red-300 border-red-400/40" },
};
